import { useEffect } from "react";
import { useQueryClient } from "react-query";
import { useLocation } from "react-router-dom";
import AllChats from "src/views/assistant/components/splashScreen/AllChats";
import { useChatStore } from "src/views/assistant/stores/ChatStore";
import { renderChatKindBadge } from "./components/ChatKindChip";
import {
  buildPartsAIChatUrl,
  PARTS_AI_LISTING_PRODUCT_KEY_BY_KIND,
  type PartsAIListingKind,
} from "./utils/chatUrl";

const PartsAIRecentsPage = () => {
  const { setProductConfig, registerChatUrlBuilder } = useChatStore();
  const queryClient = useQueryClient();
  const location = useLocation();
  // Recents are kind-scoped via ?kind=run|search|comparison so the list stays
  // homogeneous and the registered builder routes every entry correctly.
  // Default to "run" so a bare /parts/recents keeps its prior behavior.
  const kindParam = new URLSearchParams(location.search).get("kind");
  const kind: Exclude<PartsAIListingKind, "all"> =
    kindParam === "search"
      ? "search"
      : kindParam === "comparison"
        ? "comparison"
        : "run";
  const productKey = PARTS_AI_LISTING_PRODUCT_KEY_BY_KIND[kind];

  useEffect(() => {
    setProductConfig({
      productKey,
      productName: "Parts AI",
      basePath: "/parts",
    });
    registerChatUrlBuilder(productKey, (dialogueId, rowKind) =>
      buildPartsAIChatUrl(dialogueId, rowKind, queryClient),
    );
  }, [setProductConfig, registerChatUrlBuilder, queryClient, productKey]);

  return (
    <AllChats
      productKey={productKey}
      extraFilters={{ kind }}
      renderChatBadge={renderChatKindBadge}
    />
  );
};

export default PartsAIRecentsPage;
